import { jsx as _jsx } from "react/jsx-runtime";
import { AutocompleteInput } from "../AutocompleteInput";
export function SearchInput(props) {
    var paramKey = props.paramKey, value = props.value, setValue = props.setValue, gqlQuery = props.gqlQuery, icon = props.icon;
    var handleChange = function (e) {
        e.persist();
        setValue(e.target.value);
    };
    var handleSelect = function (val) {
        setValue(val);
    };
    return (_jsx(AutocompleteInput, { name: paramKey, value: value, placeHolderText: props.placeholder, gqlQuery: gqlQuery, icon: icon, handleChange: handleChange, handleDropdownItemSelect: handleSelect }));
}
